// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { graphql } from 'react-relay';

import useMutation from './useMutation';

const mutation = graphql`
  mutation useLoginMutation($email: String!, $password: String!) {
    authenticateUser(email: $email, password: $password) {
      __typename
      ... on AuthenticateUserSuccess {
        viewer {
          currentUser {
            customerNumber
          }
          ...SessionLayout_viewer
        }
      }
      ... on AuthenticateUserInvalidInput {
        fieldErrors {
          fieldName
          errors
        }
      }
    }
  }
`;

export default function useLoginMutation({ onComplete, onError }) {
  return useMutation(mutation, { onComplete, onError });
}
